import { GET_AUTH_USER_TYPES, GET_ORG_AFFILIATION } from 'api/aaaService';
import apolloClient from 'api/apolloClient';
import { makeAutoObservable } from 'mobx';
import { Agency, UserRoleTypes } from 'types/aaaService';

export default class AaaStore {
  // eslint-disable-next-line class-methods-use-this
  async getOrgAffiliation(): Promise<Agency[]> {
    const res = await apolloClient.query<{ getOrgAffiliationV2: Agency[] }>({
      query: GET_ORG_AFFILIATION,
      fetchPolicy: 'no-cache',
    });
    return res.data.getOrgAffiliationV2;
  }

  // eslint-disable-next-line class-methods-use-this
  async getAuthUserTypes(): Promise<UserRoleTypes[]> {
    const res = await apolloClient.query<{ getAuthUserTypes: UserRoleTypes[] }>({
      query: GET_AUTH_USER_TYPES,
      fetchPolicy: 'no-cache',
    });
    return res.data.getAuthUserTypes;
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
